var map = {
	"./vip-1.gif": 2005,
	"./vip-1.svg": 2006,
	"./vip-10.gif": 2007,
	"./vip-10.svg": 2008,
	"./vip-11.gif": 2009,
	"./vip-11.svg": 2010,
	"./vip-12.gif": 2011,
	"./vip-12.svg": 2012,
	"./vip-2.gif": 2013,
	"./vip-2.svg": 2014,
	"./vip-3.gif": 2015,
	"./vip-3.svg": 2016,
	"./vip-4.gif": 2017,
	"./vip-4.svg": 2018,
	"./vip-5.gif": 2019,
	"./vip-5.svg": 2020,
	"./vip-6.gif": 2021,
	"./vip-6.svg": 2022,
	"./vip-7.gif": 2023,
	"./vip-7.svg": 2024,
	"./vip-8.gif": 2025,
	"./vip-8.svg": 2026,
	"./vip-9.gif": 2027,
	"./vip-9.svg": 2028,
	"./vip-bg.jpg": 2029,
	"./vip10-bg.jpg": 2030,
	"./vip11-bg.jpg": 2031,
	"./vip12-bg.jpg": 2032
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2004;